export default "__VITE_ASSET__CTkmCQm9__"